import { render, staticRenderFns } from "./DamageRoll.vue?vue&type=template&id=12ad933f"
import script from "./DamageRoll.vue?vue&type=script&lang=js"
export * from "./DamageRoll.vue?vue&type=script&lang=js"
import style0 from "./DamageRoll.vue?vue&type=style&index=0&id=12ad933f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports